<template>
  <div>

    <table class="table table-striped table-sm">
      <thead>
      <tr>
        <th scope="col"></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(service, index) in services"
          :key="index"
      >
        <td>{{service.name}}</td>
        <td style="text-align: right">
          <router-link class="btn btn-secondary" :to="{name: 'service', params: { id: service.id } }">
            Перейти
          </router-link>
        </td>
      </tr>
      </tbody>
    </table>

    <ServiceCreate :project-id="props.projectId"/>
  </div>
</template>

<script setup>
import {defineProps, computed} from 'vue'
const props  = defineProps({
  projectId: String,
})

import {useServiceStore} from '@/store/services'
import ServiceCreate from "@/views/projects/ServiceCreate";
const serviceStore = useServiceStore()
const services = computed(() => serviceStore.items)
if(props.projectId) {
  serviceStore.getListByProject(props.projectId)
} else {
  serviceStore.getList()
}

</script>
